interface SectionContainerProps extends React.HTMLAttributes<HTMLElement> {
	children: React.ReactNode;
	className?: string;
	withBackground?: boolean;
}

export function SectionContainer({
	children,
	className = '',
	withBackground = false,
	...props
}: SectionContainerProps) {
	return (
		<section
			{...props}
			className={`py-8 md:py-8 ${withBackground ? 'rounded-3xl bg-white shadow-sm' : ''} ${className} `}>
			<div className="container relative z-10 mx-auto px-4">
				{children}
			</div>
		</section>
	);
}
